import(/* webpackMode: "eager" */ "/home/runner/work/minimals-showcase/minimals-showcase/src/sections/generate-page/view/generate-page-view.tsx")